export default __webpack_public_path__ + "static/media/logo-login.5a4dca98.png";